<template>
  <div class="forgot-password-ltr" dir="ltr">
    <ForgotPassword />
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref } from "vue";
import ForgotPassword from "@/components/Modules/Authentication/ForgotPassword/index.vue";

export default defineComponent({
  name: "ForgotPasswordPage",
  components: {
    ForgotPassword,
  },
  setup() {
    const originalDirection = ref("");

    onMounted(() => {
      document.body.classList.add("bg-white");
      
      // Save original direction and force LTR for forgot-password page
      originalDirection.value = document.body.getAttribute("dir") || "ltr";
      document.body.setAttribute("dir", "ltr");
    });

    onBeforeUnmount(() => {
      document.body.classList.remove("bg-white");
      
      // Restore original direction when leaving forgot-password page
      document.body.setAttribute("dir", originalDirection.value);
    });
  },
});
</script>

<style scoped>
.forgot-password-ltr {
  direction: ltr !important;
  text-align: left !important;
}

.forgot-password-ltr * {
  direction: ltr !important;
}
</style>
